"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var RelType = {
  CANONICAL: 'canonical',
  NEXT: 'next',
  PREV: 'prev'
};

var CanonicalLink = function CanonicalLink(_ref) {
  var passedHref = _ref.href,
      rel = _ref.rel;
  var href = (0, _react.useMemo)(function () {
    return passedHref.replace(/\/$/, '');
  }, [passedHref]);
  return _react.default.createElement("link", {
    rel: rel,
    href: href
  });
};

CanonicalLink.propTypes = {
  rel: _propTypes.default.oneOf(Object.values(RelType)),
  href: _propTypes.default.string.isRequired
};
CanonicalLink.defaultProps = {
  rel: RelType.CANONICAL
};
var _default = CanonicalLink;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/elements/CanonicalLink.js
// module id = 785
// module chunks = 209 210 211 212